import { ROUTES_HOME } from '@/constants/routes';

export default {
    path: '/home',
    name: ROUTES_HOME,
    component() {
        return import(/* webpackChunkName: 'home' */ '@/views/Home.vue');
    }
};
